/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import { Chip } from "@mui/material";
import { UseMaterialColors } from "lib/hooks";

interface sectorPermissionChipProps {
	label: "Sector Admin" | "Plant User";
}

/**
 * Sector Permission Chip component
 * Displays a chip for "Sector Admin" or "Plant User" role
 */
export function SectorPermissionChip({ label }: sectorPermissionChipProps) {
	const materialColors = UseMaterialColors();
	const isSectorAdmin = label === "Sector Admin";
	const isDark = materialColors.isDark;

	// Color configuration based on label and theme
	const backgroundColor = isSectorAdmin
		? isDark
			? "#2A3A4A"
			: "#E3E8F0"
		: isDark
			? "#263d30"
			: "#E3E8F0";

	const borderColor = isSectorAdmin ? "#2196F3" : "#4CAF50";

	const boxShadow = isDark
		? "0 2px 6px rgba(0, 0, 0, 0.3)"
		: "0 2px 6px rgba(0, 0, 0, 0.15)";

	return (
		<Chip
			label={label}
			size="medium"
			sx={{
				fontWeight: 500,
				height: 36,
				px: 0.625, // 5px
				borderRadius: 1.5, // 6px
				justifyContent: "center",
				backgroundColor,
				border: `1px solid ${borderColor}`,
				boxShadow,
				"& .MuiChip-label": {
					fontSize: "1rem",
					fontWeight: 500,
				},
			}}
		/>
	);
}
